@charset "UTF-8";
:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._mobileHiddenPanel_1rjuj_8 {
  font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
  font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--wbu-font-weight-regular);
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  position: absolute;
  z-index: 2;
  top: 20px;
  right: 30px;
  bottom: 80px;
  padding-bottom: 130px; }
  ._mobileHiddenPanel_1rjuj_8 ._description_1rjuj_20 {
    padding: 18px 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #dfe5eb; }
    ._mobileHiddenPanel_1rjuj_8 ._description_1rjuj_20 span {
      color: #3b4057; }
  ._mobileHiddenPanel_1rjuj_8 ._noItems_1rjuj_28 {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #d5d5d5; }
  ._mobileHiddenPanel_1rjuj_8 ._footer_1rjuj_34 {
    padding: 18px 24px;
    position: absolute;
    bottom: 0;
    display: flex;
    border-top: solid 1px #dfe5eb; }
    ._mobileHiddenPanel_1rjuj_8 ._footer_1rjuj_34 ._footerContent_1rjuj_40 {
      border: solid 1px #dfe5eb;
      padding: 18px; }
      ._mobileHiddenPanel_1rjuj_8 ._footer_1rjuj_34 ._footerContent_1rjuj_40 ._footerTitle_1rjuj_43 {
        display: flex;
        align-items: center;
        color: #000624;
        margin-bottom: 6px; }
        ._mobileHiddenPanel_1rjuj_8 ._footer_1rjuj_34 ._footerContent_1rjuj_40 ._footerTitle_1rjuj_43 ._infoSmall_1rjuj_48 {
          color: #868aa5;
          margin-right: 6px; }

._withRedesignExperiment_1rjuj_52 ._mobileHiddenPanel_1rjuj_8 ._description_1rjuj_20 {
  padding: 18px; }

._withRedesignExperiment_1rjuj_52 ._mobileHiddenPanel_1rjuj_8 ._footer_1rjuj_34 {
  border-top: solid 1px #dfe5eb;
  padding: 18px 24px; }
  ._withRedesignExperiment_1rjuj_52 ._mobileHiddenPanel_1rjuj_8 ._footer_1rjuj_34 ._footerContent_1rjuj_40 {
    border: none;
    padding: 4px 0 0 4px; }
    ._withRedesignExperiment_1rjuj_52 ._mobileHiddenPanel_1rjuj_8 ._footer_1rjuj_34 ._footerContent_1rjuj_40 ._footerTitle_1rjuj_43 {
      margin-bottom: 4px; }
      ._withRedesignExperiment_1rjuj_52 ._mobileHiddenPanel_1rjuj_8 ._footer_1rjuj_34 ._footerContent_1rjuj_40 ._footerTitle_1rjuj_43 ._hintSmall_1rjuj_63 {
        color: #868aa5;
        margin-right: 6px; }
